// ----------------------------------------------------------------------------
// Nombre del Programa : SobreNosotros
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 23/JUN/2024
// Descripcion General : Clase que se utiliza para mostrar el aviso de privacidad de la pagina de prosa
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './AvisoPrivacidad.scss';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useEffect, useState, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { getContenidoDinamico } from '../../Services/ConfiguracionesService';

let quill: any = null;

export const AvisoPrivacidad = () => {
  const [cargado, setCargado] = useState<boolean>(false);
  const [titulo, setTitulo] = useState('');
  const [contenido, setContenido] = useState('');

  const quillEl = useRef(null);

  useEffect(() => {
    const quillRef: any = quillEl?.current;
    if (quillRef) {
      quill = quillRef?.getEditor();
    }
  }, []);

  useEffect(() => {
    getContenidoDinamico("AVP").then((response) => {
      if (response.data && response.data.data) {
        setTitulo(response.data.data.titulo);
        setContenido(response.data.data.contenido);
        setCargado(true);
        /*setEditorState(EditorState.createWithContent(
          ContentState.createFromBlockArray(
            htmlToDraft(response.data.data[0].contenido)
          )));*/
      }
    });
  }, []);


  return (
    <>
      <div className="mt-4">
        <Row className="mt-3">
          <Col>
            <Row className="titulo">
              <Col className="h4">{titulo}</Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
                <ReactQuill
                  ref={quillEl}
                  theme="snow"
                  placeholder=""
                  className="printer-class qlesolotexto"
                  readOnly={true}
                  value={contenido}
                  preserveWhitespace
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};
